import { Button ,Skeleton, Avatar} from "antd";
import React, { memo, useMemo, useState, forwardRef , useRef , useImperativeHandle } from "react";
import ReactPlayer from "react-player";
import styled from "styled-components";
import { femaleAI, maleAI } from "utils/assets/images";
import { UserOutlined } from "@ant-design/icons";
import usePermissionForUser from "components/hooks/permissions/usePermissionForUser";
import TranscriptWithAudio from "components/UI/transcriptWithAudio/transcriptWithAudio";
import SentryWrap from 'components/Sentry';
const Container = styled.div`
  position: relative;
  width: ${(p) => (p.player ? "100%" : "fit-content")};
  float: right;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
`;

const AuidoPlayerWrapper = styled.div`
  min-width: 86%;
  padding: 0px 6px 0 8px;
  margin-bottom: 10px;
  margin-top: 10px;

  @media Screen and (max-width: 600px) {
    margin-bottom: 6px;
    margin-top: 6px;
    max-width: 76% !important;
    width: 76%;
    min-width: unset !important;
  }
`;
const InputSkeleton = styled(Skeleton.Input)`
    width: 100% !important;
    border-radius: 20px;
    height: 40px;
    &.ant-skeleton-element {
    width: 100% !important;
    }
`;

const AudioPlayerSkeleton = () => {
  return (
    <div style={{
      padding: '8px',
      borderRadius: '16px',
      display: 'flex',
      alignItems: 'center',
      gap: '12px',
      width: '100%'
    }}>
      {/* Avatars */}
      <Avatar active size={40} icon={<UserOutlined />} style={{ border: '2px solid red' }} />
      <Avatar active size={40} icon={<UserOutlined />} />

      {/* Audio UI Skeleton */}
      <div style={{ flex: 1 , width:"100%" }}>
        <InputSkeleton  active />
      </div>
    </div>
  );
};
const AudioReader = forwardRef(
    ({ styles = {}, male_audio, female_audio, player = false, onTimeUpdate, onVoiceChange, paragraph }, ref) => {
        const [audioVersion, setAudioVersion] = useState("female");
        const player_timerref = useRef(null);
        const audioRef = useRef(null);
        const audio_url = useMemo(
            () => (audioVersion === "male" ? male_audio : female_audio),
            [audioVersion, male_audio, female_audio]
        );

        const handleVoiceChange = (version) => {
            setAudioVersion(version);
            if (onVoiceChange) onVoiceChange(version);
        };

        // const handleProgress = ({ playedSeconds }) => {
        //     if (onTimeUpdate) onTimeUpdate(playedSeconds * 1000);
        // };
        const onPlay = () => {
            if (player_timerref.current) clearInterval(player_timerref.current);

            player_timerref.current = setInterval(() => {
                const player = audioRef.current;
                if (!player || player.getInternalPlayer()?.paused) return;

                const time = player.getCurrentTime?.();
                if (time != null) {
                    onTimeUpdate((time * 1000)+400); // convert to ms
                }
            }, 50);
        };
        const onPause = () => {
            if (player_timerref.current) {
                clearInterval(player_timerref.current);
                player_timerref.current = null;
            }
        };

        const onEnded = () => {
            if (player_timerref.current) {
                clearInterval(player_timerref.current);
                player_timerref.current = null;
            }
        };
        useImperativeHandle(ref, () => ({
            setTime: (timeInMs) => {
              if (audioRef.current) {
                const seconds = timeInMs / 1000;
                onTimeUpdate(timeInMs);
                audioRef.current.seekTo(seconds, "seconds");
              }
            },
          }));
        const renderVoiceButton = (src, version) => (
            <Button
                disabled={false}
                type="link"
                style={{ borderRadius: 50 }}
                onClick={() => handleVoiceChange(version)}
                icon={
                    <img
                        src={src}
                        style={{
                            width: "100%",
                            border: audioVersion === version ? "1px solid red" : 0,
                            borderRadius: 50,
                        }}
                    />
                }
            />
        );

        if (!male_audio && !female_audio) return <AudioPlayerSkeleton/>;

        return (
          <SentryWrap>
            <Container player={player} style={{ ...styles }}>
                {renderVoiceButton(femaleAI, "female")}
                {renderVoiceButton(maleAI, "male")}
                <AuidoPlayerWrapper>
                  <TranscriptWithAudio audioUrl={audio_url} paragraph={paragraph}>
                    <ReactPlayer
                        ref={audioRef}
                        url={audio_url}
                        height="40px"
                        width="100%"
                        controls
                        playsinline
                        onPlay={onPlay}
                        onPause={onPause}
                        onEnded={onEnded}
                        config={{
                            file: {
                                forceAudio: true,
                                attributes: { controlsList: "nodownload" },
                            },
                        }}
                    />
                    </TranscriptWithAudio>
                </AuidoPlayerWrapper>
            </Container>
          </SentryWrap>
        );
    }
);

export default memo(AudioReader);